import type { FilterDefConfig, GenericFilterModel } from '@tractian/ui-filters'
import { CalendarIcon } from '@tractian/icons'

import { DayRangePicker } from '@/components/date-picker'
import { resolveInitialLanguage } from '@/app/i18n'
import { DateService } from '@/services/date/DateService'
import type { DateRangeFilter } from '@/features/assessments/utils/assessment-date-range-params'

type DateRangeFilterKey = 'startedAt' | 'lastUpdatedAt' | 'finishedAt' | 'lastOnsiteAt'

type MakeDateRangeFilterDefParams = {
  key: DateRangeFilterKey
  label: string
}

export function makeAssessmentDateRangeFilterDef({
  key,
  label
}: MakeDateRangeFilterDefParams): FilterDefConfig<GenericFilterModel, DateRangeFilter> {
  return {
    key,
    icon: <CalendarIcon />,
    label,
    defaultPinned: true,
    clearable: true,
    labelGetter: ({ value }) => {
      const language = resolveInitialLanguage()
      const fromLabel = value?.from ? DateService.formatDayLabel(value.from, language) : null
      const toLabel = value?.to ? DateService.formatDayLabel(value.to, language) : null
      if (fromLabel && toLabel) return [`${fromLabel} – ${toLabel}`]
      if (fromLabel) return [`From ${fromLabel}`]
      if (toLabel) return [`To ${toLabel}`]
      return []
    },
    getFallbackValue: () => ({}),
    valueSetter: ({ newValue }) => ({
      [key]: newValue ?? {}
    }),
    renderContent: ({ value, onChange }) => {
      return <DayRangePicker value={value} onChange={next => onChange(next)} />
    }
  }
}
